"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useProgressBar_unstable", {
    enumerable: true,
    get: ()=>useProgressBar_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactField = require("@fluentui/react-field");
const _reactUtilities = require("@fluentui/react-utilities");
const _index = require("../../utils/index");
const useProgressBar_unstable = (props, ref)=>{
    const field = (0, _reactField.useFieldContext_unstable)();
    const fieldState = field === null || field === void 0 ? void 0 : field.validationState;
    const { color =fieldState === 'error' || fieldState === 'warning' || fieldState === 'success' ? fieldState : 'brand' , shape ='rounded' , thickness ='medium'  } = props;
    var _props_max;
    const max = (0, _index.clampMax)((_props_max = props.max) !== null && _props_max !== void 0 ? _props_max : 1);
    const value = (0, _index.clampValue)(props.value, max);
    const root = (0, _reactUtilities.getNativeElementProps)('div', {
        ref,
        role: 'progressbar',
        'aria-valuemin': value !== undefined ? 0 : undefined,
        'aria-valuemax': value !== undefined ? max : undefined,
        'aria-valuenow': value,
        'aria-labelledby': field === null || field === void 0 ? void 0 : field.labelId,
        ...props
    });
    if (field && (field.validationMessageId || field.hintId)) {
        // Prepend the field's validation message and/or hint to the user's aria-describedby
        root['aria-describedby'] = [
            field === null || field === void 0 ? void 0 : field.validationMessageId,
            field === null || field === void 0 ? void 0 : field.hintId,
            root['aria-describedby']
        ].filter(Boolean).join(' ');
    }
    const bar = (0, _reactUtilities.resolveShorthand)(props.bar, {
        required: true
    });
    const state = {
        color,
        max,
        shape,
        thickness,
        value,
        components: {
            root: 'div',
            bar: 'div'
        },
        root,
        bar
    };
    return state;
}; //# sourceMappingURL=useProgressBar.js.map

//# sourceMappingURL=useProgressBar.js.map